import type { SelfServiceSource } from '../../cash-division/components/DisbursementRequestModal';
import { myDisbursementRequestsApi, type CashRequester } from './myDisbursementRequestsApi';

/**
 * What turns the Cash Division's request form into the Self Service one — the caller's own
 * endpoints, and the requesting party STATED rather than picked.
 *
 * Before `/me` answers — or if it never does — the label is just "You": the form still opens,
 * because the server is the authority and states its own refusal for an unlinked account.
 */
export function selfServiceSource(requester: CashRequester | null): SelfServiceSource {
  return {
    requesterLabel:
      requester?.employeeNumber != null
        ? `You — ${requester.employeeNumber}`
        : requester?.error != null
          ? 'You — no employee record is linked to this account'
          : 'You',
    loadCatalog: myDisbursementRequestsApi.catalog,
    create: myDisbursementRequestsApi.create,
    update: myDisbursementRequestsApi.update,
  };
}
